module.exports = __webpack_public_path__ + "img/icon_hot.da8dc860.png";